<template>
  <div>
    <div class="row">
      <div class="col-md-8">
        <h3 class="header-row semi-bold">Fabric Assets</h3>
      </div>
      <div class="col-md-4 text-right">
        <button class="btn btn-primary" @click="exportAsCsv()">
          Export to Excel
        </button>
      </div>
    </div>
    <div class="grid">
      <div class="grid-body custom-grid-header">
        <div class="row">
          <div class="col-md-8 text-bold rate">
            Exchange Rate: 1 USD =
            <span v-if="fabrics.length > 0"
              >{{ ezy.comma(fabrics[0].exchange_rate.thb) }} THB</span
            >
            <span v-else>0 THB</span> |
            <span v-if="fabrics.length > 0"
              >{{ ezy.comma(fabrics[0].exchange_rate.eur) }} EUR</span
            >
            <span v-else>0 EUR</span>
          </div>
          <div class="col-md-4 text-right">
            <div class="mt-10">
              <p-radio
                class="p-default p-curve"
                color="danger"
                name="currency"
                v-model="defaultCurrencyModel"
                :value="null"
                @change="changeCurrency()"
                >DEFAULT</p-radio
              >
              <p-radio
                class="p-default p-curve"
                color="danger"
                name="currency"
                v-model="defaultCurrencyModel"
                value="USD"
                @change="changeCurrency()"
                >USD</p-radio
              >
              <p-radio
                class="p-default p-curve"
                color="danger"
                name="currency"
                v-model="defaultCurrencyModel"
                value="THB"
                @change="changeCurrency()"
                >THB</p-radio
              >
              <p-radio
                class="p-default p-curve"
                color="danger"
                name="currency"
                v-model="defaultCurrencyModel"
                value="EUR"
                @change="changeCurrency()"
                >EUR</p-radio
              >
            </div>
          </div>
        </div>
      </div>
      <div class="grid-body">
        <table class="table table-striped table-bordered">
          <tbody class="custom-table-header">
            <tr>
              <td colspan="3" class="text-center first-header">Fabric</td>
              <td rowspan="2" class="text-center first-header sortable" @click="sort('unit_price')">
                <SortableHeader column="unit_price" :selected-column="sortColumn" :sort-direction="sortDirection">
                  Unit Price <br /><em>(last order)</em>
                </SortableHeader>
              </td>
              <td colspan="2" class="text-center first-header">In Stock</td>
              <td colspan="2" class="text-center first-header">Ordered</td>
              <td rowspan="2" class="text-center first-header sortable" @click="sort('sub_total')">
                <SortableHeader column="sub_total" :selected-column="sortColumn" :sort-direction="sortDirection">Total Value</SortableHeader>
              </td>
              <td rowspan="2" class="text-center first-header">Currency</td>
            </tr>
            <tr>
              <td class="second-header sortable" @click="sort('id')">
                <SortableHeader column="id" :selected-column="sortColumn" :sort-direction="sortDirection">ID</SortableHeader>
              </td>
              <td class="second-header">Image</td>
              <td class="second-header sortable" @click="sort('name')">
                <SortableHeader column="name" :selected-column="sortColumn" :sort-direction="sortDirection">Name</SortableHeader>
              </td>
              <td class="second-header sortable" @click="sort('in_stock')">
                <SortableHeader column="in_stock" :selected-column="sortColumn" :sort-direction="sortDirection">Meter</SortableHeader>
              </td>
              <td class="second-header sortable" @click="sort('stock_value')">
                <SortableHeader column="stock_value" :selected-column="sortColumn" :sort-direction="sortDirection">
                  Value ({{ defaultCurrency }})
                </SortableHeader>
              </td>
              <td class="second-header sortable" @click="sort('ordered_amount')">
                <SortableHeader column="ordered_amount" :selected-column="sortColumn" :sort-direction="sortDirection">Meter</SortableHeader>
              </td>
              <td class="second-header sortable" @click="sort('order_value')">
                <SortableHeader column="order_value" :selected-column="sortColumn" :sort-direction="sortDirection">
                  Value ({{ defaultCurrency }})
                </SortableHeader>
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td colspan="3"></td>
              <td class="text-right text-bold">* = converted</td>
              <td colspan="4" class="text-right text-bold">Grand Total</td>
              <td class="text-right text-bold">
                {{ ezy.comma(grandTotalValue(defaultCurrency)) }}
              </td>
              <td class="text-center text-bold">
                {{ defaultCurrency }}
              </td>
            </tr>
            <tr v-for="fabric in fabrics" :key="fabric.id">
              <td>
                <router-link :to="'/fabric/update/' + fabric.id">{{
                  $Fabric.getCode(fabric.id)
                }}</router-link>
              </td>
              <td class="fabric-image">
                <img :src="fabric.image_url" class="img" alt="" />
              </td>
              <td>
                <router-link :to="'/fabric/update/' + fabric.id">{{
                  fabric.name
                }}</router-link>
              </td>
              <td class="text-right">
                {{ ezy.comma(fabric.unit_price) }}
                <em v-if="fabric.converted_price"
                  >* [{{ fabric.conversion_reason }}]</em
                >
              </td>
              <td class="text-right">
                {{ ezy.comma(fabric.in_stock) }}
              </td>
              <td class="text-right">
                {{ ezy.comma(fabric.stock_value) }}
              </td>
              <td class="text-right">
                {{ ezy.comma(fabric.ordered_amount) }}
              </td>
              <td class="text-right">
                {{ ezy.comma(fabric.order_value) }}
              </td>
              <td class="text-right">
                {{
                  ezy.comma(
                    fabric.sub_total
                  )
                }}
              </td>
              <td class="text-center">
                {{ fabric.currency }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import SortableHeader from "./components/SortableHeader"

export default {
  components: { SortableHeader },
  data() {
    return {
      fabrics: [],
      original: [],
      defaultCurrencyModel: null,
      defaultCurrency: "USD",
      sortColumn: 'id',
      sortDirection: 'asc'
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    /**
     * fetch the fabric assets data
     * setting the original value is to calculate back the original currency value
     */
    async getData() {
      let response = await axios.get("/v2/fabrics/assets");
      let fabrics = response.data.data.map((fabric) => {
        // format the conversion reason
        fabric["converted_price"] =
          fabric["default_unit"] !== "m"
        let conversionReason = [];
        if (fabric["default_unit"] !== "m") {
          conversionReason.push("Yd");
        }
        fabric["conversion_reason"] = conversionReason.join("|");

        // format the fabric image
        let images = fabric.images;
        if (images.length > 0) {
          // Use backend as main image
          let image = images.find((img) => {
            return img.type === "backend";
          });
          // Use the first image if the previous type is not found.
          if (!image) {
            image = images[0];
          }
          fabric["image_url"] = image.image_url;
        } else {
          fabric["image_url"] = "/assets/img/fabric-placeholder.png";
        }

        //
        fabric['stock_value'] = fabric['in_stock'] * fabric['unit_price']
        fabric['order_value'] = fabric['ordered_amount'] * fabric['unit_price']
        fabric['sub_total'] = fabric['stock_value'] + fabric['order_value']

        return fabric;
      });

      this.original = fabrics;
      this.fabrics = fabrics;
    },

    /**
     * fetch the fabric assets data
     * setting the original value is to calculate back the original currency value
     */
    async exportAsCsv() {
      try {
        let res = await axios({
          url: "/v2/fabrics/assets/export?currency=" + this.defaultCurrency,
          method: "GET",
          responseType: "blob", // important
        });
        if (res) {
          let blob = res.data.slice(0, res.data.size, "text/csv");

          let url = URL.createObjectURL(blob);
          window.open(url, "_blank");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error("Something Went Wrong! Please Try Again");
        }
      }
    },

    /**
     * - first change all fabrics unit price into USD
     * - then change totalPrice into requested currency with exchange Rate
     */
    changeCurrency() {
      let inputDefaultCurrency = this.defaultCurrencyModel;
      if (inputDefaultCurrency) {
        this.defaultCurrency = inputDefaultCurrency;
        this.fabrics = this.original.map((fabric) => {
          let tmp = { ...fabric };
          let amount = fabric.unit_price;
          let currency = ezy.lower(fabric.currency);
          let defaultCurrency = ezy.lower(inputDefaultCurrency);
          // unit price into USD
          let amountInUSD = amount
            ? amount / fabric.exchange_rate[currency]
            : 0;
          // change Unit Price USD into requested currency with exchange rate;
          tmp.unit_price = fabric.currency
            ? amountInUSD * fabric.exchange_rate[defaultCurrency]
            : 0;
          tmp.stock_value = fabric.in_stock * tmp.unit_price;
          tmp.order_value = fabric.ordered_amount * tmp.unit_price;
          tmp.sub_total = fabric.stock_value + tmp.order_value;
          tmp.currency = inputDefaultCurrency;
          return tmp;
        });
      } else {
        this.defaultCurrency = "USD";
        this.fabrics = this.original;
      }
      this.applySort()
    },

    /**
     * - first change all fabrics unit price into USD
     * - totalPrice = (in_stock x unit_price) + (order_amount x unit_price)
     * - then change totalPrice into requested currency with exchange Rate
     */
    grandTotalValue(inputDefaultCurrency) {
      let total = 0;
      this.original.forEach((fabric) => {
        let amount = fabric.unit_price;
        let currency = ezy.lower(fabric.currency);
        let defaultCurrency = ezy.lower(inputDefaultCurrency);
        // unit price into USD
        let amountInUSD = amount ? amount / fabric.exchange_rate[currency] : 0;
        // calculate total Price
        let totalPrice =
          fabric.in_stock * amountInUSD + amountInUSD * fabric.ordered_amount;
        // change total Price USD into requested currency with exchange rate;
        total += fabric.currency
          ? totalPrice * fabric.exchange_rate[defaultCurrency]
          : 0;
      });
      return total;
    },
    sort(column) {
      this.sortColumn = column
      this.sortDirection = this.sortDirection === "asc" ? 'desc' : 'asc';
      this.applySort()
    },
    applySort() {
      const column = this.sortColumn
      const sortDirection = this.sortDirection

      this.fabrics = this.fabrics.sort((fabricA, fabricB) => {

        if(fabricA[column] === fabricB[column]) {
          return 0
        }
        if (sortDirection === "asc") {
          return fabricA[column] < fabricB[column] ? -1 : 1;
        } else {
          return fabricA[column] > fabricB[column] ? -1 : 1;
        }
      });
    }
  },


};
</script>

<style scoped>
.custom-table-header tr td {
  font-weight: bold;
  background: var(--primary-color) !important;
  color: white;
  text-align: center;
  height: 30px;
}
.custom-table-header tr td,
.custom-table-header tr th {
  border: 0.5px solid white !important;
}
.custom-table-header tr td.sortable {
  cursor: pointer;
}
.first-header {
  position: sticky;
  top: 59px;
}
.second-header {
  position: sticky;
  top: 98px;
}
.custom-grid-header {
  padding: 10px 20px 0px 20px;
}
.rate {
  margin-top: 12px;
}
.table {
  border-collapse: inherit;
}
.table > tbody > tr > td {
  vertical-align: middle;
}
.fabric-image img {
  max-width: 50px;
}
</style>
